import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label?: string;
  isTextArea?: boolean;
}

const Input: React.FC<InputProps> = ({ label, isTextArea = false, style, className = '', ...props }) => {
  const Component = isTextArea ? 'textarea' : 'input';
  
  return (
    <div className="input-wrapper">
      {label && <label className="input-label">{label}</label>}
      <Component
        {...(props as any)}
        className={`input ${className}`}
        style={style}
      />
    </div>
  );
};

export default Input;
